<template>
  <div
    class="pa-0 d-flex form-group-container"
    :class="[
      {
        'form-group__inline flex-wrap flex-sm-nowrap': isInline,
        'form-group flex-wrap': !isInline,
      },
      classGroup,
    ]"
  >
    <div
      v-if="!noLabel"
      class="py-0 text-left pr-4 flex-grow-0 flex-shrink-0 label-name"
      :class="[
        {
          required: required,
          readonly: readonly,
          'pa-0': noPadding,
          '': isInline,
        },
        classLabel,
      ]"
    >
      <div :class="[{}, classLabel]" :style="{ width: currentWidthLabel }">
        <slot name="label-group">
          {{ label }}
        </slot>
      </div>
    </div>
    <div class="input-container" :class="{ 'pa-0': noPadding }">
      <slot :defaultRules="defaultRules" :rules="currentRules">
        <slot :defaultRules="defaultRules" name="input" :rules="currentRules">
          <fieldInput
            v-model="item"
            v-bind="attrBind"
            class=" "
            :label="noLabel ? label || '' : ''"
            :noLabel="noLabel"
            :typeInput="typeInput"
            v-on="$listeners"
          >
            <template v-for="(_, slot) in $slots" v-slot:[slot]="props">
              <slot v-bind="props" :name="slot" />
            </template>
            <template v-slot:append>
              <base-button v-if="copyable" icon @click="copyToClipboard(value)">
                <v-icon>mdi-content-copy</v-icon>
              </base-button>
              <slot name="append" />
            </template>
          </fieldInput>
        </slot>
      </slot>
    </div>
  </div>
</template>

<script>
/**
 * slots
 * input - ghi de input hien gio
 * label - ghi de label hien gio
 */
import fieldInput from './field-input.vue'
import FieldMixin from './field-mixin'
export default {
  name: 'field-group',
  inheritAttrs: false,
  mixins: [FieldMixin],
  components: { fieldInput },
  props: {
    copyable: Boolean,
    widthLabel: { type: String, default: '120px' },
    classLabel: String,
    labelDefaultColor: Boolean,
    classGroup: String,
    classInput: String,
  },
  computed: {
    slots() {
      return Object.keys(this.$scopedSlots)
    },
    currentWidthLabel() {
      if (this.isInline) return this.widthLabel
      else return '100%'
    },
    isInline() {
      return this.inline || this.awalayInline
    },
  },
  methods: {
    copyToClipboard(value) {
      this.$store.dispatch('copyToClipboard', value)
    },
  },
}
</script>
<style lang="scss" scoped>
.label-name {
  box-sizing: border-box;
  font-size: 0.8rem;
}
.theme--light .label-name {
  color: rgba(0, 0, 0, 0.6);
}
.theme--dark .label-name {
  color: rgba(255, 255, 255, 0.7);
}
.input-container {
  width: 100%;
}
.form-group__inline {
  flex-direction: row;
  .label-name {
    display: flex;
    align-items: flex-start;
    // height: 40px;
    min-height: 30px;
    margin-bottom: 20px;
    padding-top: 4px !important;
    align-items: center;
  }
  .input-container {
    flex: 1 1 auto;
  }
}
// .label-name {
//   &.required:not(.readonly) {
//     & > div::after {
//       content: '(*)';
//       padding-left: 8px;
//       display: inline-block;
//       color: var(--v-error-base);
//     }
//   }
// }
.form-group {
  flex-direction: column;
}
.form-group-container {
  .v-input {
    padding-top: 0 !important;
    margin: 0 !important;
  }
}
</style>
